import { AdminModule, AuthModule, HttpModule, ProfessorModule, RatingModule, } from "./modules";
export class Client {
    constructor(env, errorInterceptor) {
        const httpModule = new HttpModule(env.url, errorInterceptor !== null && errorInterceptor !== void 0 ? errorInterceptor : (() => { }));
        this.httpModule = httpModule;
        this.professors = new ProfessorModule(httpModule);
        this.auth = new AuthModule(httpModule);
        this.ratings = new RatingModule(httpModule);
        this.admin = new AdminModule(httpModule);
    }
    typeCheck() {
        const routes = {
            "get:/professors": this.professors.all,
            "get:/professors/:id": this.professors.get,
            "post:/professors": this.professors.new,
            "post:/login": this.auth.login,
            "post:/register": this.auth.register,
            "post:/professors/ratings": this.ratings.initiateAdd,
            "post:/rating/report": this.ratings.report,
            "get:/ratings/:id": this.ratings.finishAdd,
            "get:/admin/bulk/:key": this.admin.bulkKvKeys,
            "post:/admin/bulk/:key": this.admin.bulkKvValues,
            "get:/admin/professors/pending": this.admin.pendingProfessors,
            "delete:/admin/pending/:id": this.admin.removePendingProfessor,
            "post:/admin/pending/:id": this.admin.approvePendingProfessor,
            "delete:/admin/reports/:id": this.admin.removeReport,
            "post:/admin/reports/:id": this.admin.approveReport,
            "delete:/admin/rating/:professorId/:reviewId": this.admin.removeRating,
            "delete:/admin/professor/:id": this.admin.deleteProfessor,
            "post:/admin/professor/merge": this.admin.mergeProfessor,
            "post:/admin/professor/department": this.admin.changeProfessorDepartment,
        };
        return routes;
    }
    setErrorInterceptor(errorInterceptor) {
        this.httpModule.errorInterceptor = errorInterceptor;
    }
}
//# sourceMappingURL=Client.js.map